import { useEffect, useState } from "react";
import { useFieldArray, useForm, useWatch } from "react-hook-form";
import FormInputText from "../shared/FormInputText";
import { FaRegTrashCan } from "react-icons/fa6";
import { zodResolver } from "@hookform/resolvers/zod";
import * as z from "zod/v4";
import { useQuery } from "@tanstack/react-query";
import { fetchContent } from "../../utils/apiUtils";
import { delay } from "../../utils/commonUtils";


const tagAttributesSchema = z.object({
    key: z.string().min(1, 'Key is required.'),
    value: z.string().min(1, 'Value is required.'),
});

const formSchema = z.object({
    tagAttributes: z.array(tagAttributesSchema).min(1, 'At least one key-value pair is required.'),
});

const QInContentDetails = ({ data, queryKey, tagResourceoMutation }) => {
    const [errorMessage, setErrorMessage] = useState()

    const { isPending, error, data: fetchContentData, refetch } = useQuery({
        queryKey: ['fetchContent', data.contentId],
        queryFn: async () => {
            const resutls = await fetchContent({
                contentId: data.contentId,
                knowledgeBaseId: data.knowledgeBaseId
            })
            return resutls.content
        }
    })


    const {
        control,
        register,
        formState: { errors, isValid, isDirty, dirtyFields, isSubmitting, isSubmitSuccessful },
        getValues,
        handleSubmit,
    } = useForm({
        resolver: zodResolver(formSchema),
        defaultValues: {
            //  tagAttributes: [{ key: '', value: '' }]
        },
        values: {
            tagAttributes: Object.entries(data?.tags)?.map(([key, value]) => ({ key, value }))
        },
        mode: "onSubmit"
    });

    const { fields, append, prepend, remove, swap, move, insert } = useFieldArray({
        control, // control props comes from useForm (optional: if you are using FormProvider)
        name: "tagAttributes", // unique name for your Field Array
    });


    const onSubmit = async (values) => {

        try {
            const tags = values.tagAttributes?.reduce((acc, currentItem) => {
                acc[currentItem.key] = currentItem.value;
                return acc;
            }, {})

            await tagResourceoMutation.mutateAsync({
                resourceArn: fetchContentData.contentArn,
                tags,
                tagsKeysToRemove: Object.keys(data?.tags).filter(tag => !(tag in tags))
            })
            await delay(1000)
            refetch()
        } catch (err) {
            setErrorMessage(err.message)
        }


    }

    const onError = (err) => {
        setErrorMessage(err.message)
    }

    return (
        <div style={{ padding: '0rem 0rem 1rem 0rem' }}>

            <p style={{ fontWeight: 600, fontSize: '1.4rem', padding: '0rem 0rem 0rem 0rem' }}>{data?.metadata?.['s3.bucket.name']}</p>
            <a target="_blank" href={`${fetchContentData?.url}`}>{data?.metadata?.['s3.object.key']}</a>

            <p style={{ fontSize: '1.2rem', padding: '2rem 0rem 0rem 0rem' }}>Tags</p>
            <form onSubmit={handleSubmit(onSubmit, onError)} className="form" style={{}}>

                {fields.map((field, index) => (
                    <div key={field.id} style={{ padding: '1rem 0rem 0rem 0rem', display: 'flex', gap: '1rem', justifyContent: 'center', alignItems: 'center' }}>

                        <FormInputText label={'Key'} name={`tagAttributes.${index}.key`} register={register} errors={errors} placeholder="Key" />
                        <FormInputText label={'Value'} name={`tagAttributes.${index}.value`} register={register} errors={errors} placeholder="Value" />

                        <FaRegTrashCan style={{ cursor: 'pointer', width: '10%' }} size={"1.6rem"} color={"var(--red)"} onClick={() => remove(index)} />


                    </div>
                ))}

                {isValid && <div style={{ padding: '0rem 0rem 3rem 0rem' }}>
                    <button type="button" onClick={() => append({ key: '', value: '' })} className="btn add-btn">
                        Add tag
                    </button>
                </div>}



                {/* {JSON.stringify(data)} */}

                {errorMessage && <p className="danger" style={{ padding: '0rem 0rem 2rem 0rem' }}>{errorMessage}</p>}

                {/* Display validation error for the entire list (if there are no pairs) */}
                {errors.tagAttributes && (
                    <p style={{ color: 'red', marginTop: '10px' }}>
                        {errors.tagAttributes.message}
                    </p>
                )}

                {isSubmitting ? <div className="loader" /> : <input
                    className="btn"
                    type="submit"
                    disabled={Object.keys(dirtyFields).length && !isValid}
                    value={'Save'} />}

            </form>
        </div>
    )
}

export default QInContentDetails